import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
  colors
} from '@material-ui/core';

import EditAppointment from '../../EditAppointment/EditAppointment';

const useStyles = makeStyles(theme => ({
    root: {},
    
    content: {
        padding: 0
    },

    actions: {
        flexDirection: 'column',
        alignItems: 'flex-end',
            '& > * + *': {
            marginLeft: 0
        }
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    },

    editButton: {
        color: theme.palette.white,
        backgroundColor: colors.blue[600],
        '&:hover': {
        backgroundColor: colors.blue[900]
        }
    }
    
}));

// export default function DetailData(props) {

//     const { appointments, className, ...rest } = props;

//     const classes = useStyles();
  
//     const [openEdit, setOpenEdit] = useState(false);
  
//     const handleEditOpen = () => {
//       setOpenEdit(true);
//     };
  
//     const handleEditClose = () => {
//       setOpenEdit(false);
//     };

//     return (
//         <Card
//             {...rest}
//             className={clsx(classes.root, className)}
//         >
//             <CardHeader title="Appointment Detail" />
//             <Divider />
//             <CardContent className={classes.content}>
//                 <Table>
//                     <TableBody>
//                     <TableRow>
//                         <TableCell>Slot</TableCell>
//                         <TableCell>
//                             {appointments.slot}
//                         </TableCell>
//                     </TableRow>
//                     <TableRow>
//                         <TableCell>Appointment</TableCell>
//                         <TableCell>{appointments.appointment}</TableCell>
//                     </TableRow>
//                     <TableRow>
//                         <TableCell>Booking Date</TableCell>
//                         <TableCell>{appointments.bookingdate}</TableCell>
//                     </TableRow>
                    
//                     </TableBody>
//                 </Table>
//             </CardContent>
//             <CardActions className={classes.actions}>
//                 <Button className={classes.editButton} onClick={handleEditOpen}>
//                     Edit
//                 </Button>
               
//             </CardActions>
//             <EditAppointment
//                 appointments={appointments}
//                 onClose={handleEditClose}
//                 open={openEdit}
//             />
//         </Card>
//     );
// }
export default class DetailData extends React.Component{

    constructor(props){
        super(props);
        console.log('DetailData');
        console.log(props);
        this.state = {
            appointments: props.appointments,
            appointment_id: props.appointment_id  
        };
    }

    componentWillReceiveProps(props){
        this.setState({
            appointments: props.appointments
        });
    }
    
    // const {  className, ...rest } = props;
    // const admins = props.admins;
    // const classes = useStyles();
  
    // const [openEdit, setOpenEdit] = useState(false);
  
    handleEditOpen() {
      //setOpenEdit(true);
    };
  
    handleEditClose(){
      //setOpenEdit(false);
    };

    toPage(appointment_id){
        window.location.href = '/appointment/detailappointment/'+ appointment_id;
    };

    render(){
            return (
                <Card
                    {...this.props.rest}
                    className={clsx(this.props.classes.root, this.props.className)}
                >
                    <CardHeader title="Appointment Detail" />
                    <Divider />
                    <CardContent className={this.props.classes.content}>
                        <Table>
                            <TableBody>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>{this.state.appointments.date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Time</TableCell>
                                <TableCell>{this.state.appointments.start_time} - {this.state.appointments.end_time}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Showroom</TableCell>
                                <TableCell>{this.state.appointments.property}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Agent</TableCell>
                                <TableCell>{this.state.appointments.agent}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Pax</TableCell>
                                <TableCell>
                                    {this.state.appointments.pax}
                                </TableCell>
                            </TableRow>
                            
                            
                            
                            </TableBody>
                        </Table>
                    </CardContent>
                    <CardActions className={this.props.classes.actions}>
                        {/* <Button className={this.props.classes.editButton} onClick={this.handleEditOpen}>
                            Edit
                        </Button> */}
                    
                    </CardActions>
                    {/* <EditAppointment
                        appointments={this.props.appointments}
                        onClose={this.handleEditClose}
                        open={this.openEdit}
                    /> */}
                </Card>
            );
        }   
}

